module.exports = __webpack_public_path__ + "static/media/know13.aa57a24a.jpg";